<template>
  <div class="authority-container">
    <div class="authority-table-wrap" style="height: calc(100vh - 323px);">
      <div class="authority-table-item" v-for="(item,index) in allRoleMenu" :key="item.menuId">
        <!-- 标题头 -->
        <div class="authority-title">
          <Check :itemValue="item" @select="handlecheck">{{item.menuName}}</Check>
        </div>
        <!-- 第一级 -->
        <div class="authority-li" v-for="oneItem in item.menu" :key="oneItem.menuId">
          <div class="li-one">
            <Check :itemValue="oneItem" @select="handlecheck">{{oneItem.menuName}}</Check>
          </div>
          <!-- 第二级 -->
          <div class="two-container">
            <div class="li-two" v-for="twoItem in oneItem.menu" :key="twoItem.menuId">
              <div class="li-two-wrap">
                <Check :itemValue="twoItem" @select="handlecheck">{{twoItem.menuName}}</Check>
              </div>
              <!-- 第三级 -->
              <div class="three-container" >
                <div class="li-three-wrap">
                  <div class="li-three" v-for="threeItem in twoItem.menu" :key="threeItem.menuId">
                    <Check :itemValue="threeItem"  @select="handlecheck">{{threeItem.menuName}}</Check>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-wrap">
       <el-button type="primary" @click="handleSave">保存</el-button>
    </div>
    <TipDialog ref="tipdialog" />
  </div>
</template>
<script>
import {sysRoleMenu,updateRoleMenuId} from "@/api/role/role.js";
import Check from "@/views/system/roleComponents/check.vue"
import TipDialog from "@/views/system/roleComponents/tipDialog.vue"
export default {
  name: "Authority",
  props:["roleId","empMenuId","roleEmp"],
  components: {
    Check,
    TipDialog
  },
  data() {
    return {
      sidebarFlag: 1,                      // 1 全不选 2全选 3非全选且非全不选
      allRoleMenu: [],                     // 存放所有权限树
      // stutusFlag: true,                   // true为所有者，false为非所有者
      updataParams: {
        roleId: '',
        menuId: []
      },
      // myPoint: {},
      // showUsedPoint: 0,
      selectAllStaff: []                  // 当前角色选中的成员
    };
  },
  methods: {
    // 侧边栏是否有选中 true 说明没有选中
    isSelectCBL(tree) {
      for(let i = 0; i<tree.length; i++) {
        if(tree[i].flag == 1) {
          if(tree[i].menu.length>0) {
            if(!this.isSelectCBL(tree[i].menu)) {
              return false
            }
          }
        }else {
          return false
        }
      }
      return true
    },
    // 选择事件
    handlecheck(val) {
      if(val.flag == 1) {
        // 未选中
        val.flag = 2;
        // 将子集flag全部置为2
        this.setAll(val.menu,2)
        this.selectToFather(this.allRoleMenu,val.parentMenuId)
      }else {
        // 选中  将flag置为1(未选)
        val.flag = 1
        this.setAll(val.menu,1)
      }
      // 重新区分是全选还是部分选
      this.checkIsAllSelect()
       // 返回true说明没有选中
    },
    // 保存按钮
    handleSave() {
      // if(this.showUsedPoint > this.myPoint.totalPoint) {
      //   let num = this.myPoint.totalPoint - this.myPoint.usedPoint
      //   this.$refs.tipdialog.show(num)
      // }else {
      //   this.updataParams.menuId = [];
      //   this.allSelect(this.allRoleMenu)
      //   this.updateRoleMenuId(this.updataParams)
      // }
      this.updataParams.menuId = [];
      this.allSelect(this.allRoleMenu)
      this.updateRoleMenuId(this.updataParams)
    },
    // 查找选中的项
    allSelect(tree) {
      for(let i = 0; i < tree.length; i++) {
        if(tree[i].flag != 1) {
          this.updataParams.menuId.push(tree[i].menuId)
        }
        if(tree[i].menu.length>0) {
          this.allSelect(tree[i].menu)
        }
      }
    },
    // 选中子级 反选父级
    selectToFather(tree,menuId) {
      for(let i = 0; i<tree.length;i++) {
        if(tree[i].menuId == menuId) {
          tree[i].flag = 3
          if(tree[i].parentMenuId != 0) {
            this.selectToFather(this.allRoleMenu,tree[i].parentMenuId)
          }
          
        }else {
          this.selectToFather(tree[i].menu,menuId)
        }
      }
    },
    // 将权限树的所有flag置为某一个值
    setAll(tree,val) {
      
      for(let i = 0; i< tree.length;i++) {
        // if(tree[i].menuId == 51) {
        //   if(this.stutusFlag) {
        //     tree[i].flag = val
        //   }else {
        //     tree[i].flag = 1
        //   }
        // }else {
        //   tree[i].flag = val
        //   if(tree[i].menu.length>0) {
        //     this.setAll(tree[i].menu,val)
        //   }
        // }
        tree[i].flag = val
        if(tree[i].menu.length>0) {
          this.setAll(tree[i].menu,val)
        }
      }
    },
    setTreeFlag(arr) {
      function set(tree,menuId) {
        for(let i = 0; i < tree.length;i++) {
          if(tree[i].menuId == menuId) {
            // 找到这个节点
            tree[i].flag = 3
          }else {
            // 继续查找下一个
            set(tree[i].menu,menuId)
          }
        }
      }
      // 先将有选中的标上
      for(let j=0;j<arr.length;j++) {
        set(this.allRoleMenu,arr[j])
      }
      // 再区分是全选中还是部分选中 即flag是2还是3
      this.checkIsAllSelect()
    },
    checkIsAllSelect() {
      function setAll(tree) {
        for(let i = 0;i<tree.length;i++) {
          if(tree[i].flag != 1) {
            if(tree[i].menu.length>0) {
              if(!setAll(tree[i].menu)) {
                return false
              }
            }
          }else {
            return false
          }
        }
        return true
      }
      function second(tree) {
        for(let m=0;m<tree.length;m++) {
          if(tree[m].flag != 1) {
            let status = setAll(tree[m].menu)  
            if(status) {
              // 全选
              tree[m].flag = 2
            }else {
              // 非全选
              tree[m].flag = 3
            }
          }
          if(tree[m].menu.length>0) {
            second(tree[m].menu)
          }
        }
      }
      second(this.allRoleMenu)
    },
    // 获取所有权限树
    getSysRoleMenu() {
      sysRoleMenu(localStorage.getItem("Authorization")).then(res => {
        if(res.error.code == 200) {
          this.allRoleMenu = res.data.menus;
        }else {
          this.$message.error("获取权限树失败,请重试！");
        }
      }).catch(err => {
        this.$message.error("获取权限树失败,请重试！");
      })
    },
    // 更改权限
    updateRoleMenuId(params) {
      updateRoleMenuId(params,localStorage.getItem("Authorization"),true).then(res => {
        if(res.error.code == 200) {
          this.$message({
            type: 'success',
            message: '更改权限成功!'
          });
          this.$emit("reGet")
        }else if(res.error.code == 203) {
          this.$refs.tipdialog.show(res.data)
        }else {
          this.$message.error("更改权限失败,请重试！");
        }
      }).catch(err => {
        this.$message.error("更改权限失败,请重试！");
      })
    },
    
  },
  created() {
    this.getSysRoleMenu()
  },
  computed: {
    // 需要增加的人数
    // addNun() {
    //   let num = 0
    //   this.selectAllStaff.forEach(roleItem => {
    //     if(this.myPoint.userSidebarList) {
    //       this.myPoint.userSidebarList.forEach(pointItem => {
    //         if(pointItem.userId == roleItem.userId) {
    //           num++
    //           return
    //         }
    //       });
    //     }
    //   })
    //   return this.selectAllStaff.length - num
    // }
  },
  watch: {
    // status: {
    //   handler(newVal,oldVal) {
    //     if(newVal == 0) {
    //       // 所有者
    //       this.stutusFlag = true
    //     }else {
    //       // 非所有者
    //       this.stutusFlag = false
    //     }
    //   }
    // },
    roleId: {
      handler(newVal,oldVal) {
        this.updataParams.roleId = newVal
      },
    },
    empMenuId: {
      handler(newVal,oldVal) {
        this.setAll(this.allRoleMenu,1)
        this.setTreeFlag(newVal)
      },
      deep: true
    },
    roleEmp: {
      handler(newVal,oldVal) {
        this.selectAllStaff = JSON.parse(JSON.stringify(newVal))
      },
      deep:true
    },
    // point: {
    //   handler(newVal,oldVal) {
    //     this.myPoint = newVal
    //     this.showUsedPoint = JSON.parse(JSON.stringify(this.myPoint.usedPoint))
    //   },
    //   deep:true
    // }
  }
};
</script>
<style lang="scss" scoped>
.authority-container {
  font-size: 13px;
  height: 100%;
  display: flex;
  flex-direction: column;
  // .authority-tip {
  //   margin-bottom: 20px;
  //   color: #AAAAAA;
  //   font-size: 13px;
  // }
  .authority-table-wrap {
    
    overflow-y: scroll;
  }
  .authority-table-item {
    margin-bottom: 25px;
    .authority-title {
      padding: 8px;
      background-color: #F5F8FC;
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .num-tip-container {
        color: #AAAAAA !important;
        padding: 0 10px;
      }
      .num-tip-container1 {
        padding: 0 10px;
      }
      .num-tip {
        margin-left: 20px;
        .over-num {
          color: red;
        }
      }
    }
    .authority-li {
      display: flex;
      border: 1px solid #ebeef5;
      margin-bottom: 10px;
      .li-one {
        border-right: 1px solid #ebeef5;
        min-width: 160px;
        padding: 20px 0 20px 15px;
      }
      .li-one,.li-two,.li-three {
        
      }
      .two-container {
        flex: 1;
      }
      .li-two {
        display: flex;
        width: 100%;
        border-bottom: 1px solid #ebeef5;
        .li-two-wrap {
          padding: 20px 0 20px 15px;
          width: 160px;
          border-right: 1px solid #ebeef5;
        }
        .li-three {
          padding: 20px 0 20px 15px;
          flex: 1;
        }
        .three-container {
            flex: 1;
        }
      }
      .li-two:last-child {
        border-bottom: none;
      }
    }
    .authority-li:last-child {
      margin-bottom: 0px;
    }
  }
  .authority-table-item:last-child {
    margin-bottom: 0;
  }
  .btn-wrap {
    margin-top: 25px;
    padding-top: 15px;
    border-top: 1px solid #ebeef5;
    box-shadow: 0 -8px 15px 2px #ebeef5;
    display: flex;
    justify-content: flex-end;
  }
}
</style>